var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import ReactDOM from 'react-dom';
import ChordPanel from '../views/ChordPanel';
import { DropDownDiv, Field } from 'blockly/core';
import { getNoteName } from '../utils/Notes';
var experiments = require('@cdo/apps/util/experiments');
var MAX_DISPLAY_NOTES = 3;
/**
 * A custom field that renders the chord selection UI, used in the
 * "play_chord" block. The UI is rendered by {@link ChordPanel}.
 */
var FieldChord = /** @class */ (function (_super) {
    __extends(FieldChord, _super);
    function FieldChord(options) {
        var _this = _super.call(this, options.currentValue) || this;
        _this.options = options;
        _this.newDiv = null;
        _this.SERIALIZABLE = true;
        _this.CURSOR = 'default';
        return _this;
    }
    FieldChord.fromJson = function (options) {
        return new FieldChord(options);
    };
    FieldChord.prototype.saveState = function () {
        return this.getValue();
    };
    FieldChord.prototype.loadState = function (state) {
        this.setValue(state);
    };
    FieldChord.prototype.initView = function () {
        this.createBorderRect_();
        this.createTextElement_();
        if (this.borderRect_) {
            this.borderRect_.classList.add('blocklyDropdownRect');
        }
    };
    FieldChord.prototype.applyColour = function () {
        var style = this.sourceBlock_.style;
        if (this.borderRect_) {
            this.borderRect_.setAttribute('stroke', style.colourTertiary);
            this.borderRect_.setAttribute('fill', 'transparent');
        }
        if (this.textElement_) {
            if (experiments.isEnabled('zelos')) {
                this.textElement_.style.fill = 'white';
            }
        }
    };
    FieldChord.prototype.getText = function () {
        var _a = this.getValue(), notes = _a.notes, instrument = _a.instrument;
        if (notes.length === 0) {
            return 'select notes';
        }
        return "".concat(instrument, " (").concat(this.getTruncatedNotes(notes), ")");
    };
    FieldChord.prototype.render_ = function () {
        _super.prototype.render_.call(this);
        this.renderContent();
    };
    FieldChord.prototype.showEditor_ = function () {
        _super.prototype.showEditor_.call(this);
        var editor = this.createDropdown();
        DropDownDiv.getContentDiv().appendChild(editor);
        var style = this.sourceBlock_.style;
        DropDownDiv.setColour(style.colourPrimary, style.colourTertiary);
        DropDownDiv.showPositionedByField(this, this.disposeDropdown.bind(this));
    };
    FieldChord.prototype.createDropdown = function () {
        this.newDiv = document.createElement('div');
        this.renderContent();
        this.newDiv.style.color = 'white';
        this.newDiv.style.width = 'auto';
        this.newDiv.style.backgroundColor = 'black';
        this.newDiv.style.padding = '5px';
        return this.newDiv;
    };
    FieldChord.prototype.renderContent = function () {
        var _this = this;
        if (!this.newDiv) {
            return;
        }
        ReactDOM.render(React.createElement(ChordPanel, {
            library: this.options.getLibrary(),
            initValue: this.getValue(),
            previewChord: this.options.previewChord,
            onChange: function (value) { return _this.setValue(value); }
        }), this.newDiv);
    };
    FieldChord.prototype.disposeDropdown = function () {
        this.newDiv = null;
    };
    FieldChord.prototype.getTruncatedNotes = function (notes) {
        var allNotes = notes
            .map(function (note) { return getNoteName(note); })
            .slice(0, MAX_DISPLAY_NOTES)
            .join(', ');
        return notes.length > MAX_DISPLAY_NOTES ? allNotes + '...' : allNotes;
    };
    return FieldChord;
}(Field));
export default FieldChord;
